function languageSelector() {
  var directive = {
    template: require('./languageSelector.html'),
    restrict: 'E',
    replace: true,
    controller: LanguageController,
    controllerAs: 'languageController',
    bindToController: true
  };

  function LanguageController($scope, coreService, $translate) {
    var vm = this;
    vm.isOpen = false;
    vm.focusIndex = -1;

    activate();

    function activate() {
      var model = coreService.getIdentityModel();

      if (model.loginUrl && model.siteUrl) {
        coreService
          .getProductLanguages(model.siteUrl)
          .then(function(response) {
            vm.productLanguages = response.data;
            var currentLanguage = findCurrentLanguage(vm.productLanguages);

            if (!!currentLanguage) {
              vm.selectedLanguage = currentLanguage;
              $scope.selectedLanguage = vm.selectedLanguage;
            } else {
              vm.changeLanguage(findDefaultLanguage(vm.productLanguages));
            }
          });
      }
    }

    vm.changeLanguage = function(productLanguage) {
      var model = coreService.getIdentityModel();

      if (model && model.custom) {
        model.custom.language = productLanguage.productLanguageId;
        model.custom.ui_locales = productLanguage.code;
      }

      coreService.updateIdentityModelLanguage(model);

      vm.selectedLanguage = productLanguage;
      $scope.selectedLanguage = productLanguage;

      $translate.use(productLanguage.code);
    };

    vm.keyDown = function(e) {
      switch (e.keyCode) {
          case 32:
          case 13:
              e.preventDefault();
              vm.isOpen = !vm.isOpen;
              
              if (vm.isOpen) {
                vm.focusIndex = -1;
              }
          break;
        case 40:
        case 9:
          if (vm.isOpen) {
            e.preventDefault();
            vm.focusIndex = (vm.focusIndex >= vm.productLanguages.length - 1) ? 0 : vm.focusIndex + 1;
            vm.changeFocus(vm.focusIndex);
          }
          break;
        case 38:
          if (vm.isOpen) {
            vm.focusIndex = (vm.focusIndex <= 0) ? vm.productLanguages.length - 1 : vm.focusIndex - 1;
            vm.changeFocus(vm.focusIndex);
          }
          break;
      }
    };

    vm.changeFocus = function(i) {
      var el = document.getElementById("lang-" + i);
      el.focus();
    };

    vm.selectByKeyDown = function(e, language) {
      switch (e.keyCode) {
        case 32:
        case 13:
          vm.changeLanguage(language);
          break;
      }
    };

    // Function that finds the language in the model
    function findCurrentLanguage(productLanguages) {
      var currentLanguage;
      var keepGoing = true;
      var currentProductLanguage = coreService.getCurrentProductLanguage();

      angular.forEach(productLanguages, function(productLanguage) {
        if (keepGoing && productLanguage.productLanguageId == currentProductLanguage) {
          currentLanguage = productLanguage;
          keepGoing = false;
        }
      });

      return currentLanguage;
    }

    // Function that finds the default product language
    function findDefaultLanguage(productLanguages) {
      var defaultLanguage = productLanguages.length > 0 ? productLanguages[0] : {};
      var keepGoing = true;

      angular.forEach(productLanguages, function(productLanguage) {
        if (keepGoing && productLanguage.isProductDefaultLanguage == true) {
          defaultLanguage = productLanguage;
          keepGoing = false;
        }
      });

      return defaultLanguage;
    }

  };

  return directive;
};
export default languageSelector;


// WEBPACK FOOTER //
// ./src/login/languageselector/languageSelector.js